// extracted by mini-css-extract-plugin
var _1 = "uC4Xk";
var _2 = "G70dG";
var _3 = "anszD";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
